import { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { TextField, Checkbox,FormControlLabel, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import "../css/Contacts.css";

const API_URL = "https://your-api.com/users";

export default function Contacts() {
  const { register, handleSubmit, reset, setValue } = useForm();
  const [users, setUsers] = useState([]);

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    const response = await axios.get(API_URL);
    setUsers(response.data);
  };

  const onSubmit = async (data) => {
    if (!data.id) {
      data.id = uuidv4();
      await axios.post(API_URL, data);
    } else {
      await axios.put(`${API_URL}/${data.id}`, data);
    }
    fetchUsers();
    reset();
  };

  const handleEdit = (user) => {
    Object.keys(user).forEach((key) => setValue(key, user[key]));
  };

  const handleDelete = async (id) => {
    await axios.delete(`${API_URL}/${id}`);
    fetchUsers();
  };

  return (
    <div className="contacts-container">
      <h2>Contacts</h2>
      <form onSubmit={handleSubmit(onSubmit)} className="contacts-form">
        <TextField {...register("firstName")} label="First Name" required fullWidth margin="dense" className="contacts-textfield" />
        <TextField {...register("middleName")} label="Middle Name" fullWidth margin="dense" className="contacts-textfield" />
        <TextField {...register("lastName")} label="Last Name" required fullWidth margin="dense" className="contacts-textfield" />
        <TextField {...register("primaryEmailId")} label="Primary Email" required fullWidth margin="dense" className="contacts-textfield" />
        <TextField {...register("secondaryEmailId")} label="Secondary Email" fullWidth margin="dense" className="contacts-textfield" />
        <TextField {...register("mobilePhone")} label="Mobile Phone" required fullWidth margin="dense" className="contacts-textfield" />
        <TextField {...register("workPhone")} label="Work Phone" fullWidth margin="dense" className="contacts-textfield" />
        <div className="contacts-checkbox-group">
          <FormControlLabel control={<Checkbox {...register("isOkToWhatsApp")} />} label="WhatsApp" className="contacts-checkbox" />
          <FormControlLabel control={<Checkbox {...register("isOkToSms")} />} label="SMS" className="contacts-checkbox" />
        </div>
        <Button type="submit" variant="contained" color="primary">Submit</Button>
      </form>

      <TableContainer component={Paper} className="contacts-table-container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user.id}>
                <TableCell>{`${user.firstName} ${user.middleName} ${user.lastName}`}</TableCell>
                <TableCell>{user.primaryEmailId}</TableCell>
                <TableCell>{user.mobilePhone}</TableCell>
                <TableCell>
                  <Button onClick={() => handleEdit(user)} variant="outlined">Edit</Button>
                  <Button onClick={() => handleDelete(user.id)} variant="contained" color="secondary" style={{ marginLeft: "10px" }}>Delete</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
